import axios, { AxiosInstance } from 'axios'
import Keycloak from 'keycloak-js'
import { ROUTES } from '@shared/constants/routes'
import { getAuthCallbackUrl } from '@shared/lib/authRedirect'

// this thing is used for requests with auth header
export let authAxios: AxiosInstance = axios.create()

type AccessTokenProvider = () => Promise<string | null>

const getClientTimezone = (): string | null => {
	try {
		return Intl.DateTimeFormat().resolvedOptions().timeZone || null
	} catch {
		return null
	}
}

const getAuthHeaders = (accessToken: string): Record<string, string> => {
	const headers: Record<string, string> = {
		Authorization: `Bearer ${accessToken}`,
	}
	const timezone = getClientTimezone()
	if (timezone) {
		headers['X-Timezone'] = timezone
	}
	return headers
}

class ApiService {
	private tokenAccessToken: string | null = null
	private tokenAccessTokenProvider: AccessTokenProvider | null = null
	private tokenInterceptorConfigured = false

	public setup(keycloak: Keycloak): void {
		if (!keycloak.token) {
			console.error('Токен Keycloak отсутствует.')
			return
		}

		this.tokenAccessToken = null
		this.tokenAccessTokenProvider = null
		this.tokenInterceptorConfigured = false

		authAxios = axios.create({
			headers: getAuthHeaders(keycloak.token),
		})

		authAxios.interceptors.request.use(async config => {
			if (keycloak.isTokenExpired(30)) {
				try {
					await keycloak.updateToken(30)
					config.headers.Authorization = `Bearer ${keycloak.token}`
				} catch (error) {
					console.error('Не удалось обновить токен:', error)
					keycloak.logout({
						redirectUri: getAuthCallbackUrl(ROUTES.overall.hello),
					})
				}
			}
			const timezone = getClientTimezone()
			if (timezone) {
				config.headers['X-Timezone'] = timezone
			}
			return config
		})
	}

	public setupToken(accessToken: string, accessTokenProvider: AccessTokenProvider): void {
		if (!accessToken) {
			console.error('Access token отсутствует.')
			return
		}

		this.tokenAccessToken = accessToken
		this.tokenAccessTokenProvider = accessTokenProvider

		if (this.tokenInterceptorConfigured) return

		authAxios = axios.create()
		authAxios.interceptors.request.use(async config => {
			const nextAccessToken = await this.tokenAccessTokenProvider?.()
			const accessToken = nextAccessToken ?? this.tokenAccessToken
			if (!accessToken) {
				throw new Error('Active auth session is missing')
			}

			config.headers.Authorization = `Bearer ${accessToken}`
			const timezone = getClientTimezone()
			if (timezone) {
				config.headers['X-Timezone'] = timezone
			}
			return config
		})
		this.tokenInterceptorConfigured = true
	}
}

// Yes, it's costyl, but it's only used in auth providers and hard to change to normal
export const apiService = new ApiService()
